import { EventBusyOutlined, VpnKeyOutlined } from '@mui/icons-material'
import { Alert, AlertTitle } from '@mui/material'
import { FunctionComponent } from 'react'

import type { LicenciaProductoProps } from '../../../../../base/interfaces/licenciaProducto'
import { fechaVencimientoTexto, licenciaVencida } from '../../../../../base/services/licenciaProductoVigencia'

interface Props {
  /** `li.licencia` de la sesión: si está ACTIVADA pero vencida, el aviso indica la fecha */
  licencia?: Partial<LicenciaProductoProps> | null
}

/**
 * Aviso para las pantallas de impresoras cuando el comercio no tiene licencia de impresión vigente
 * (`li.activo` o vencida). Esas pantallas solo muestran este aviso: sin licencia no se gestionan impresoras.
 */
const IsiPrintSinLicenciaAviso: FunctionComponent<Props> = ({ licencia }) => {
  if (licencia?.state === 'ACTIVADO' && licenciaVencida(licencia)) {
    return (
      <Alert severity="error" icon={<EventBusyOutlined />}>
        <AlertTitle>La licencia de impresión venció</AlertTitle>
        La licencia de impresión del comercio venció el {fechaVencimientoTexto(licencia)}. Renuévela con su
        proveedor para volver a gestionar impresoras e imprimir con isi-print.
      </Alert>
    )
  }
  return (
    <Alert severity="warning" icon={<VpnKeyOutlined />}>
      <AlertTitle>isi-print sin licencia</AlertTitle>
      El comercio no cuenta con una licencia de impresión activa. Solicítela a su proveedor.
    </Alert>
  )
}

export default IsiPrintSinLicenciaAviso
